export class HRKeyResponsibilityArea {
  id:                   string;
  hrConfigId:           string;
  ownerEmployeeId:      string;
  title:                string;
  description:          string;
  active = true;
}
// End of class
